<script setup>
import { defineProps } from 'vue'
import Jumbo from '@/components/Docs/Jumbo.vue'

defineProps({ anchor: String })
</script>

<template>
  <jumbo title="Rate limits" :anchor="anchor">
    <p>
      Our API operates under a fair-use policy to keep the platform stable and
      responsive for everyone. Data endpoints are rate limited: each request
      charges one credit against your account's quota, and bulk endpoints charge
      one credit per item (for example, a 50-IP bulk lookup charges 50 credits).
    </p>
    <p>
      When a request would exceed your quota, the API responds with
      <strong>429 Too Many Requests</strong>. Requesting an endpoint or dataset
      your account is not granted returns <strong>403 Forbidden</strong>.
    </p>
    <p><strong>Fair-use principles</strong></p>
    <ul>
      <li><strong>Efficient use</strong>, minimize unnecessary calls; prefer bulk endpoints and cursors over tight polling.</li>
      <li><strong>Non-abusive behavior</strong>, avoid usage patterns that degrade service quality for others.</li>
      <li><strong>Respect limits</strong>, do not attempt to bypass or circumvent rate limiting.</li>
    </ul>
    <p>
      We monitor usage patterns and reserve the right to throttle, suspend, or
      revoke access in cases of abuse. Questions about your limits? Contact support
      and we'll help.
    </p>
  </jumbo>
</template>
